// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "./js/checkout-sweetener/" + "checkout-sweetener.checkout-sweetener.plugin" + "." + "12bdb5" + ".js";
};